export default __webpack_public_path__ + "static/media/comic.1ab7d245.jpg";